/* eslint-disable no-unused-vars */
import WS from '../util/Websocket';
import { closeTopic, updateMessage } from './actions';
import { ROOT_SLICE } from '../constants';
import UTIL_FALCON_UPLOAD_MESSAGE from '../util/message';
import { goodEnoughUUID } from '../../../../../../../scanline/utils/uuid';

const REF_UNSUBSCRIBE = {};

const HAS_ERROR = 'HAS_ERROR';

const KEY_STEP_01 = 'Step01IdentifySurveys';
const KEY_STEP_02 = 'Step02RemoveDataIfNeeded';
const KEY_STEP_03 = 'Step03ParseAndSaveBySurveyType';

const KEY_DONE = 'Done';

const KEYS_SURVEY_TYPE = [
	'ONOFF',
	'ON',
	'DEPOL',
	'NATIVE',
	'DCVG',
	'ACCA',
	'DOC',
	'ACVG',
	'ACPSP',
	'PROFILE',
	'REPORTEDANOMALIES'
];

const parseJson = json => {
	try {
		return JSON.parse(json);
	} catch (e) {
		return json;
	}
};

export const thunkPollingMigrationStatusComplete = ({ topic }) => dispatch => {
	if (REF_UNSUBSCRIBE[topic]) {
		const unsubscribe = REF_UNSUBSCRIBE[topic];
		unsubscribe();
		delete REF_UNSUBSCRIBE[topic];

		dispatch(closeTopic({ topic }));
	}
};

export const thunkCreateStep3ErrorMessageDetails = message => dispatch => {
	const isError = message?.isError || message?.body?.isError;
	const history = parseJson(message?.body?.history) || {};
	const hasStep03Error = history[KEY_STEP_03] === HAS_ERROR;

	if (isError && hasStep03Error) {
		const failedSurveyParses = KEYS_SURVEY_TYPE.filter(
			k => history[k] === HAS_ERROR
		)
			.join(', ')
			.trim();
		if (failedSurveyParses.length) {
			const newMessage = UTIL_FALCON_UPLOAD_MESSAGE.createMonitorFalconProcessorMessage(
				message.topic,
				{
					...message?.body,
					isError: true,
					uuid: goodEnoughUUID(),
					desc: '',
					batch: 'STEP_03_ERROR_DETAILS',
					errDesc: failedSurveyParses
				}
			);
			dispatch(updateMessage({ message: newMessage }));
		}
	}
};

export const thunkOnRecieveWSServerMessage = ({ topic, data }) => dispatch => {
	setTimeout(() => {
		const { action } = data;
		if (action === 'monitor-falcon-processor') {
			const message = UTIL_FALCON_UPLOAD_MESSAGE.createMonitorFalconProcessorMessage(
				topic,
				{ ...(data?.body || {}) }
			);
			dispatch(updateMessage({ message }));
			const { isComplete, forceStop } = message?.body || {};
			if (isComplete || forceStop) {
				dispatch(thunkCreateStep3ErrorMessageDetails(message));
				dispatch(thunkPollingMigrationStatusComplete({ topic }));
			}
		}
	}, 1);
};

export const thunkPollingMigrationStatusStart = ({
	topic,
	jobNumber,
	lineName
}) => dispatch => {
	// subscribe
	const { unsubscribe } = WS.subscribe(topic, {
		receiveMessage: (_topic, data) => {
			if (data.error) {
				console.error('Error from server:', data.error);
			} else {
				setTimeout(() => {
					dispatch(thunkOnRecieveWSServerMessage({ topic: _topic, data }));
				}, 1);
			}
		},
		owner: ROOT_SLICE
	});

	// prep unsubscribe
	REF_UNSUBSCRIBE[topic] = unsubscribe;

	// WS.consoleLogState();

	dispatch(
		updateMessage({
			message: UTIL_FALCON_UPLOAD_MESSAGE.createMigrationStartMessage(topic)
		})
	);
	// initiate polling
	WS.sendMessage({
		action: 'monitor-falcon-processor',
		topic,
		body: {
			jobNumber,
			lineName
		}
	});

	// WS.consoleLogState();
};

export default {
	thunkOnRecieveWSServerMessage,
	thunkPollingMigrationStatusStart,
	thunkPollingMigrationStatusComplete
};
